import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCyberEdit = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "currentColor",
	viewBox: "0 0 16 16",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		clipPath: "url(#a)",
		clipRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("path", { d: "M13.824.423a.25.25 0 0 1 .353 0l1.4 1.4a.25.25 0 0 1 0 .354l-6.5 6.5a.3.3 0 0 1-.08.053L6.572 9.755a.25.25 0 0 1-.328-.325l1-2.425a.3.3 0 0 1 .055-.082zM7.687 7.242l-.749 1.816 1.82-.77L15.046 2 14 .953z" }), /* @__PURE__ */ _jsx("path", { d: "M.35 2.9a.25.25 0 0 1 .25-.25h8a.25.25 0 1 1 0 .5H.85v12h12V7.4a.25.25 0 1 1 .5 0v8a.25.25 0 0 1-.25.25H.6a.25.25 0 0 1-.25-.25zM12.523 1.723a.25.25 0 0 1 .354 0l1.4 1.4a.25.25 0 0 1-.354.354l-1.4-1.4a.25.25 0 0 1 0-.354" })]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", { d: "M0 0h16v16H0z" })
	}) })]
});
export default SvgCyberEdit;
